import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	content: {
		padding: theme.spacing(3),
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(0)
	},
	message: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(5)
	},
	button: {
		margin: theme.spacing(1),
		'& .MuiButton-label': {
			color: theme.palette.text.gumetal
		}
	}
}));
